export const GET_ADHOC_ROLE_REQUEST = 'GET_ADHOC_ROLE_REQUEST';
export const GET_ADHOC_ROLE_SUCCESS = 'GET_ADHOC_ROLE_SUCCESS';
export const GET_ADHOC_ROLE_FAILURE = 'GET_ADHOC_ROLE_FAILURE';
export const SELECT_USER = 'SELECT_USER';
export const SET_SELECTED_ROLE_ID = 'SET_SELECTED_ROLE_ID';
export const SET_ROLE_USER = 'SET_ROLE_USER';
export const SET_SHARE_FILE = 'SET_SHARE_FILE';
export const GET_FILESHARING_REQUEST = 'GET_FILESHARING_REQUEST';
export const GET_FILESHARING_SUCCESS = 'GET_FILESHARING_SUCCESS';
export const GET_FILESHARING_FAILURE = 'GET_FILESHARING_FAILURE';
export const SET_WEEK_SELECT_FIELD = 'SET_WEEK_SELECT_FIELD';
export const GET_WORKFLOW_USER_REQUEST = 'GET_WORKFLOW_USER_REQUEST';
export const GET_WORKFLOW_USER_SUCCESS = 'GET_WORKFLOW_USER_SUCCESS';
export const GET_WORKFLOW_USER_FAILURE = 'GET_WORKFLOW_USER_FAILURE';
export const GET_FORMDATA_FILE_REQUEST = 'GET_FORMDATA_FILE_REQUEST';
export const GET_FORMDATA_FILE_SUCCESS = 'GET_FORMDATA_FILE_SUCCESS';
export const GET_FORMDATA_FILE_FAILURE = 'GET_FORMDATA_FILE_FAILURE';
